export enum WaybillIdType {
  HAWB = 'HAWB',
  HBL = 'HBL',
  MBL = 'MBL',
  MAWB = 'MAWB',
  CarrierToCarrierID = 'CARRIER_TO_CARRIER_ID',
}
